document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('.mavie-desc__inner');
  if (!root || root.dataset.cardsApplied) return;

  const kids = Array.from(root.children);
  let buf = [];

  const flush = () => {
    if (!buf.length) return;
    const card = document.createElement('div');
    card.className = 'desc-card';
    buf[0].before(card);
    buf.forEach(el => card.appendChild(el));

    // H2の“合図”から色を決める
    const h2 = card.querySelector('h2');
    if (h2) {
      const tint = detectTint(h2);
      if (tint) card.classList.add('desc-card--tint-' + tint);
    }
    buf = [];
  };

  function detectTint(h2) {
    const raw = (h2.textContent || '').trim();

    // 1) 絵文字トリガー（ビジュアル編集で入れやすい）
    const emojiMap = { '🟨':'yellow', '🟩':'green', '🟦':'blue', '🟫':'beige', '⬜':'gray', '🩷':'pink' };
    for (const [emo, t] of Object.entries(emojiMap)) {
      if (raw.includes(emo)) {
        h2.textContent = raw.replaceAll(emo, '').trim();
        return t;
      }
    }

    // 2) カギ括弧/角括弧トリガー（例：［ベージュ］タイトル / [gray] Title）
    const m = raw.match(/(?:\[(.+?)\]|【(.+?)】)/);
    const token = (m && (m[1] || m[2])) ? (m[1] || m[2]).toLowerCase() : '';

    const map = {
      beige:  ['beige','ベージュ','sand','sable','bg-beige'],
      gray:   ['gray','grey','グレー','bg-gray'],
      green:  ['green','緑','bg-green'],
      yellow: ['yellow','黄','amber','gold','bg-yellow'],
      blue:   ['blue','青','bg-blue'],
      pink:   ['pink','ローズ','桃','rose','bg-pink']
    };

    if (token) {
      for (const [key, words] of Object.entries(map)) {
        if (words.some(w => token.indexOf(w) !== -1)) {
          h2.textContent = raw.replace(m[0], '').trim(); // 合図は見た目から消す
          return key;
        }
      }
    }

    // 3) ハッシュトリガー（例：Title #beige）
    const m2 = raw.match(/#(beige|gray|grey|green|yellow|blue|pink)\s*$/i);
    if (m2) {
      h2.textContent = raw.replace(m2[0], '').trim();
      const t = m2[1].toLowerCase();
      return t === 'grey' ? 'gray' : t;
    }

    return null; // 合図が無ければ通常の白カード
  }

  kids.forEach(el => {
    if (el.classList.contains('desc-card')) return; // 手動カードはスキップ
    if (el.tagName.toLowerCase() === 'h2') flush(); // 新しいH2で区切る
    buf.push(el);
  });
  flush();

  // H2が無い場合は全体を1カード化
  if (!root.querySelector('.desc-card') && root.children.length) {
    const card = document.createElement('div');
    card.className = 'desc-card';
    while (root.firstElementChild) card.appendChild(root.firstElementChild);
    root.appendChild(card);
  }

  root.dataset.cardsApplied = '1';
});

// === RuffRuff TOC: [xxx]は表示だけ外す + クリックで確実に飛ばす（href無し対応） ===
(function () {
  if (window.__mavieTocForceNavV2) return;
  window.__mavieTocForceNavV2 = true;

  var TOKEN = /^\s*\[[^\]]+\]\s*/;

  // 見出しテキストの正規化（[blue]等を除去・空白整理・小文字化）
  function norm(txt){
    return String(txt || '')
      .replace(TOKEN, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  // 見出しを集めて {正規化テキスト: element} の表を作る
  function buildHeadingMap(){
    var map = Object.create(null);
    document.querySelectorAll('.mavie-desc__inner h2, .mavie-desc__inner h3').forEach(function(h){
      var key = norm(h.textContent);
      if (key && !map[key]) map[key] = h;
    });
    return map;
  }

  // a の先頭テキストノードだけを安全に書き換えて [xxx] を消す（表示だけ）
  function stripTokenForAnchor(a){
    var n = a.firstChild;
    while (n && n.nodeType !== 3) n = n.firstChild;
    if (n && TOKEN.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(TOKEN, '');
  }

  // TOC内の <a> を列挙
  function queryTocAnchors(ctx){
    return (ctx || document).querySelectorAll(
      'nav.ruffruff-table-of-contents-body a,' +
      '#ruffruff-table-of-contents a,' +
      'nav[class*="ruffruff-table-of-contents"] a'
    );
  }

  function run(ctx){
    queryTocAnchors(ctx).forEach(stripTokenForAnchor);
  }

  // 初回＆後描画対応
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);

  var moTarget = document.querySelector('nav.ruffruff-table-of-contents-body') || document.body;
  new MutationObserver(function(){ run(); }).observe(moTarget, {childList:true, subtree:true});

  // ▼ クリックを常にこちらで捌く（hrefあればそれ優先／無ければ見出し照合で飛ぶ）
  document.addEventListener('click', function(ev){
    var a = ev.target.closest('nav.ruffruff-table-of-contents-body a, #ruffruff-table-of-contents a, nav[class*="ruffruff-table-of-contents"] a');
    if (!a) return;

    // 1) href="#id" を持っていればそのまま飛ばす
    var href = a.getAttribute('href');
    if (href && href.charAt(0) === '#') {
      var t1 = document.getElementById(href.slice(1));
      if (t1) {
        ev.preventDefault();
        try { t1.scrollIntoView({behavior:'smooth', block:'start'}); } catch(e){}
        if (location.hash !== href) history.pushState(null, '', href);
        return;
      }
    }

    // 2) hrefが無い／見つからない時はテキスト照合で見出しを探す
    var map = buildHeadingMap();
    var key = norm(a.textContent);
    var target = map[key];

    if (target) {
      ev.preventDefault();
      try { target.scrollIntoView({behavior:'smooth', block:'start'}); } catch(e){}
      // 見出しにIDが付いていればURLハッシュも更新
      var id = target.id;
      if (id && location.hash !== ('#'+id)) history.pushState(null, '', '#'+id);
    }
    // 見つからなければ何もしない（RuffRuff側に任せる）
  }, true); // capture で先に拾う（他スクリプトに止められても飛ばせる）
})();
